import { Button, Dropdown } from 'antd';
import DEFINE, { PATHS } from 'constants/Define';
import { HeaderListComponent, PageListComponent } from 'containers/backend/common/component/Index'
import { useGetListAppUI } from 'hooks/appUI/useGetAppUI';
import React, { Fragment, useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import AppUIList from './AppUIList/AppUIList';

const AppUI = (props) => {
    //! State
    const {match, t, appUIState} = props;
    const permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.APP);
    const [query, setQuery] = useState({
        pageIndex: 1,
        pageSize: 10,

    });
    const {data: listAppUI, isLoading, error, paging, reLoadData}  = useGetListAppUI(query);
    //! Function
    const onChangeTable = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        setQuery(newFilters);
    }
    //!Effect
    useEffect(() => {
        if(appUIState.isReloadData){
            reLoadData && reLoadData();
        }
    },[appUIState.isReloadData])
    //!Render
  return (
    <Fragment>
        <PageListComponent>
            <HeaderListComponent
                path={match.path}
                groupPath={'appui'}
                titleHeader={t('navigation.appui')}
                componentRight={
                    <Fragment>
                        {
                            permissionActions && permissionActions.allowCreate && 
                            <Link className='btn btn-primary' to={PATHS.APP.CREATE.path}>+ {t('action.create')}</Link>
                        }
                    </Fragment>
                }
            />
            <AppUIList
                isLoading={isLoading}
                listAppUI={listAppUI}
                paging={paging}
                onChangeTable={onChangeTable}
                t={t}
                permissionActions={permissionActions}
                deleteAppUIConfig={props.deleteAppUIConfig}
            />
        </PageListComponent>
    </Fragment>
  )
}

export default withTranslation()(AppUI)